import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, ViewModelBase } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { FormSectionsEnum } from "Globals/Models/FormSectionsEnum";
import { DomainStores, StoresInstance } from "Globals/Stores";
interface SaveCallback {
    section: FormSectionsEnum;
    callback: () => Promise<void>;
}
export class SaveStore extends BaseStore {
    @MobX.observable private saveFunctions = MobX.observable<SaveCallback>([]);
    @MobX.observable private privateIsSaving: boolean = false;
    @MobX.observable private privateIsSaved: boolean = true;

    public constructor() {
        super();
    }

    public init(stores: Stores, initialState: InitialState) {}

    @MobX.action
    public addCallback = (section: FormSectionsEnum, callback: () => Promise<void>): void => {
        this.saveFunctions.push({ section, callback });
    };
    @MobX.action
    public saveBySection = async (section: FormSectionsEnum): Promise<void> => {
        let saveFunction = this.saveFunctions.find((sf) => sf.section == section);
        if (saveFunction) {
            await saveFunction.callback();
        } else {
            console.log("Could not find save function");
        }
    };

    @MobX.action
    public saveAll = async (): Promise<void> => {
        this.setIsSaving(true);
        this.saveFunctions.forEach(async (saveFunction) => {
            await saveFunction.callback();
        });
        this.setIsSaving(false);
        this.setIsSaved(true);
    };

    @MobX.action
    public setIsSaving = (value: boolean): boolean => {
        return (this.privateIsSaving = value);
    };

    @MobX.computed get isSaving(): boolean {
        return this.privateIsSaving;
    }
    @MobX.action
    public setIsSaved = (value: boolean): boolean => {
        return (this.privateIsSaved = value);
    };

    @MobX.computed get isSaved(): boolean {
        return this.privateIsSaved;
    }
}
